import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HttpClientModule } from '@angular/common/http';
import { ToastComponent } from './components/toast/toast.component';
import { DietComponent } from './pages/diet/diet.component';
import { UserInfoModalComponent } from './components/user-info-modal/user-info-modal.component';
import { MealFormModalComponent } from './components/meal-form-modal/meal-form-modal.component';
import { DietFormModalComponent } from './components/diet-form-modal/diet-form-modal.component';
import { RoutinesComponent } from './pages/routines/routines.component';
import { ExerciseFormModalComponent } from './components/exercise-form-modal/exercise-form-modal.component';
import { ExerciseListModalComponent } from './components/exercise-list-modal/exercise-list-modal.component';
import { RoutineDayFormModalComponent } from './components/routine-day-form-modal/routine-day-form-modal.component';
import { RoutineGroupFormModalComponent } from './components/routine-group-form-modal/routine-group-form-modal.component';
import { TutorialsFormModalComponent } from './components/tutorials-form-modal/tutorials-form-modal.component';
import { UserConfigModalComponent } from './components/user-config-modal/user-config-modal.component';
import { PlanCreateModalComponent } from './components/plan-create-modal/plan-create-modal.component';
import { ImportUserSelectorComponent } from './components/import-user-selector/import-user-selector.component';
import { ImportObjectsSelectorComponent } from './components/import-routine-selector/import-objects-selector.component';
import { TutorialsComponent } from './pages/tutorials/tutorials.component';
import { CompleteTutorialFormComponent } from './components/complete-tutorial-form/complete-tutorial-form.component';
import { FoodFormModalComponent } from './components/food-form-modal/food-form-modal.component';
import { FoodListModalComponent } from './components/food-list-modal/food-list-modal.component';
import { RegisterSuccessComponent } from './pages/register-success/register-success.component';
import { FoodOptionsFormModalComponent } from './components/food-options-form-modal/food-options-form-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgChartsModule } from 'ng2-charts';
import { TabletHomeComponent } from './pages/tablet-home/tablet-home.component';
import { TutorialsTabletComponent } from './pages/tutorials-tablet/tutorials-tablet.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { VideoModalComponent } from './components/video-modal/video-modal.component';
import { AutomaticRoutinesListTabletComponent } from './pages/automatic-routines-list-tablet/automatic-routines-list-tablet.component';
import { TabletAutoassinedRoutinesComponent } from './pages/tablet-autoassined-routines/tablet-autoassined-routines.component';
import { AutoassignedRoutineComponent } from './components/autoassigned-routine/autoassigned-routine.component';
import { TabletRoutineFormComponent } from './components/tablet-routine-form/tablet-routine-form.component';
import { TabletRoutineComponent } from './pages/tablet-routine/tablet-routine.component';
import { UserFormsComponent } from './pages/user-forms/user-forms.component';
import { IntroductionFormAnswersComponent } from './components/introduction-form-answers/introduction-form-answers.component';
import { CheckFormAnswersComponent } from './components/check-form-answers/check-form-answers.component';
import { SingleFormsAnswersComponent } from './components/single-forms-answers/single-forms-answers.component';
import { WorkoutCalendarComponent } from './components/workout-calendar/workout-calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DayOfWeekTransformPipe } from './pipes/day-of-week-transform.pipe';
import { WorkoutDetailComponent } from './components/workout-detail/workout-detail.component';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { DietCalendarComponent } from './compoenents/diet-calendar/diet-calendar.component';
import { MealDetailComponent } from './components/meal-detail/meal-detail.component';
import { MacrosListComponent } from './components/macros-list/macros-list.component';
import { DietDetailComponent } from './components/diet-detail/diet-detail.component';
import { MobileOwnDietComponent } from './pages/mobile-own-diet/mobile-own-diet.component';
import { ContactComponent } from './pages/contact/contact.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TermsAndConditionsPage } from './pages/terms-and-conditions/terms-and-conditions.page';
import { PrivacyPolicyPage } from './pages/privacy-policy/privacy-policy.page';
import { SafeUrlPipe } from './pipes/safe-url.pipe';

registerLocaleData(localeEs, 'es-ES');

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    ToastComponent,
    DietComponent,
    UserInfoModalComponent,
    MealFormModalComponent,
    DietFormModalComponent,
    RoutinesComponent,
    ExerciseFormModalComponent,
    ExerciseListModalComponent,
    RoutineDayFormModalComponent,
    RoutineGroupFormModalComponent,
    TutorialsFormModalComponent,
    UserConfigModalComponent,
    PlanCreateModalComponent,
    ImportUserSelectorComponent,
    ImportObjectsSelectorComponent,
    TutorialsComponent,
    CompleteTutorialFormComponent,
    FoodFormModalComponent,
    FoodListModalComponent,
    RegisterSuccessComponent,
    FoodOptionsFormModalComponent,
    TabletHomeComponent,
    TutorialsTabletComponent,
    TruncatePipe,
    VideoModalComponent,
    AutomaticRoutinesListTabletComponent,
    TabletAutoassinedRoutinesComponent,
    AutoassignedRoutineComponent,
    TabletRoutineFormComponent,
    TabletRoutineComponent,
    UserFormsComponent,
    IntroductionFormAnswersComponent,
    CheckFormAnswersComponent,
    SingleFormsAnswersComponent,
    WorkoutCalendarComponent,
    DayOfWeekTransformPipe,
    WorkoutDetailComponent,
    DietCalendarComponent,
    MealDetailComponent,
    MacrosListComponent,
    DietDetailComponent,
    MobileOwnDietComponent,
    ContactComponent,
    TermsAndConditionsPage,
    PrivacyPolicyPage,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    FullCalendarModule,
    NgChartsModule,
    PdfViewerModule,
    SafeUrlPipe,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'es-ES' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
